import React from 'react';

/**
 * Tags allowed inside translated strings, used with `t.rich(key, richTags)`:
 * <em>…</em> accent italic · <br></br> line break · <nowrap>…</nowrap> keep on one line.
 */
export const richTags = {
  em: (chunks: React.ReactNode) => <em>{chunks}</em>,
  br: () => <br />,
  nowrap: (chunks: React.ReactNode) => <span className="whitespace-nowrap">{chunks}</span>,
};
